document.addEventListener("DOMContentLoaded", () => {
    const sizeGuideTables = document.querySelectorAll('.size-guide-table-info table');
    sizeGuideTables.forEach(table => {
      const tableHeaders = table.querySelectorAll('tr:first-of-type td');
      const tableRows = table.querySelectorAll('tr');
      const tableIndex = tableHeaders.length - 1;
  
      // Determine the initially selected country (first column in the table)
      const selectedCountry = tableHeaders[0].innerText.trim();
  
      const hiddenRowsIndex = [];
      const notHiddenRowsIndex = [];
  
      // Identify which columns to show/hide based on the selected country
      tableHeaders.forEach((header, index) => {
        if (!(header.innerText.trim() === selectedCountry) && index < tableIndex) {
          hiddenRowsIndex.push(index);
        } else {
          notHiddenRowsIndex.push(index);
        }
      });
  
      tableRows.forEach(row => {
        const columns = row.querySelectorAll("td");
        hiddenRowsIndex.forEach(index => {
          columns[index].classList.add("hidden");
        });
      });
  
      // Create a selector and insert it before the table
      const countrySelector = document.createElement('select');
      countrySelector.innerHTML = `
        <option value="ES/EU" selected>ES/EU</option>
        <option value="US">US</option>
        <option value="UK">UK</option>
        <option value="MEX">MEX</option>
        <option value="DE">DE</option>
        <option value="IT">IT</option>
        <option value="Waist (CM)">Waist (CM)</option>
      `;
      table.before(countrySelector);
  
      countrySelector.addEventListener("change", (e) => changeCountry(e, table));
  
      table.style.opacity = "1";
    });
  });
  
  function changeCountry(e, table) {
    const selectedValue = e.target.value;
    const tableRows = table.querySelectorAll('tr');
    const tableHeaders = table.querySelectorAll('tr:first-of-type td');
    const tableIndex = tableHeaders.length - 1;
  
    const hiddenRowsIndex = [];
    const notHiddenRowsIndex = [];
  
    // Adjust visibility of columns based on the selected value
    tableHeaders.forEach((header, index) => {
      if (!(header.innerText.trim() === selectedValue) && index < tableIndex) {
        hiddenRowsIndex.push(index);
      } else if (index < tableIndex) {
        notHiddenRowsIndex.push(index);
      }
    });
  
    tableRows.forEach(row => {
      const columns = row.querySelectorAll("td");
      hiddenRowsIndex.forEach(index => {
        columns[index].classList.add("hidden");
      });
      notHiddenRowsIndex.forEach(index => {
        columns[index].classList.remove("hidden");
      });
    });
  
    // Rebuild the country selector with the updated options
    rebuildHeaders(table);
  
    setTimeout(() => {
      const countrySelector = document.querySelector('select');
      countrySelector.innerHTML = `
        <option value="ES/EU" ${selectedValue === "ES/EU" ? "selected" : ""}>ES/EU</option>
        <option value="US" ${selectedValue === "US" ? "selected" : ""}>US</option>
        <option value="UK" ${selectedValue === "UK" ? "selected" : ""}>UK</option>
        <option value="MEX" ${selectedValue === "MEX" ? "selected" : ""}>MEX</option>
        <option value="DE" ${selectedValue === "DE" ? "selected" : ""}>DE</option>
        <option value="IT" ${selectedValue === "IT" ? "selected" : ""}>IT</option>
        <option value="Waist (CM)" ${selectedValue === "Waist (CM)" ? "selected" : ""}>Waist (CM)</option>
      `;
      countrySelector.addEventListener("change", (e) => changeCountry(e, table));
    }, 100);
  }
  
  function rebuildHeaders(table) {
    const headers = table.querySelectorAll('tr:first-of-type td');
    const countries = ["ES/EU", "US", "UK", "MEX", "DE", "IT", "Waist (CM)"];
    headers.forEach((header, index) => {
      if (index < countries.length) {
        header.innerText = countries[index];
      }
    });
  }
  